import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { useBillboard } from '../../shared/hooks/useApi/useBillboard';
import BillboardImageContent from './BillboardImageContent';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';
import { useParams } from 'react-router-dom';
import { isPageOwnerMatchedToRaw } from '../../shared/util/pageOwnerMatch';

const Billboard: React.FC = () => {
  const { isOwner } = useAuth();
  const { getBillboard, getBillboardForOwner } = useBillboard();
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { HANDLE: raw } = useParams<{ HANDLE?: string }>();

  useEffect(() => {
    const fetchBillboard = async () => {
      if (!isPageOwnerMatchedToRaw(raw, pageOwner)) return;

      if (isOwner) {
        await getBillboardForOwner();
      } else {
        await getBillboard();
      }
    };
    fetchBillboard();
  }, [raw, pageOwner?.aui, isOwner]);

  return (
    <BillboardComp>
      <ImgWrapper>
        <BillboardImageContent />
      </ImgWrapper>
    </BillboardComp>
  );
};

const BillboardComp = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: clamp(25px, 3vw, 50px) clamp(20px, 2vw, 30px);
`;

export const ImgWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;


export default Billboard;
